import { shallowEqual } from 'react-redux';

import { PropsWithChildren } from 'react';
import { useAppSelector } from '../../store/hooks';
import { selectCurrentUser } from '../../store/user/selectors';

export enum Roles {
  SETTINGS_ADMIN = 'settings-admin',
  MANAGER = 'manager',
}

export const Authorized = ({ children, roles }: PropsWithChildren<{ roles: Roles[] }>) => {
  const currentUser = useAppSelector(selectCurrentUser, shallowEqual);

  const hasRole = currentUser && roles.some(role => currentUser.roles.includes(role));

  if (!hasRole) return null;

  return <>{children}</>;
};
